import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_GuardianTypeSetup } from "../shared/data.service";
import { ParentRelationshipUpdateRequest } from "../shared/ParentRelationshipUpdateRequest";
import { StringIntRequest } from "../shared/StringIntRequest";

@Component({
	selector: "app-edit-guardian-type",
	templateUrl: "./edit-guardian-type.component.html",
	styleUrls: ["./edit-guardian-type.component.css"],
})
export class EditGuardianTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private GuardianTypeSetupService: DataService_GuardianTypeSetup
	) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGuardianType = this.dialogConfig.data.SelectedGuardianType;

		this.GuardianCD = this.SelectedGuardianType.RelationshipCD;
		this.OriginalCD = this.SelectedGuardianType.RelationshipCD;

		this.GuardianDesc = this.SelectedGuardianType.RelationshipDesc;
		this.OriginalDesc = this.SelectedGuardianType.RelationshipDesc;
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	SchoolID: any;
	SelectedGuardianType: any;

	//Form
	GuardianCD: any = "";
	GuardianDesc: any = "";

	OriginalCD: any = "";
	OriginalDesc: any = "";

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onEdit() {
		if (this.GuardianCD == "") {
			this.errorMessage = "Enter a code";
			return;
		}
		if (this.GuardianDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		}

		if (String(this.GuardianCD) != String(this.OriginalCD)) {
			this.CheckCD();
		} else if (String(this.GuardianDesc) != String(this.OriginalDesc)) {
			this.CheckDesc();
		} else {
			this.FinishUpdate();
		}
	}

	CheckCD() {
		let parms: StringIntRequest = {
			str: this.GuardianCD,
			num: this.SchoolID,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipCDUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Guardian Type Code/Abbreviation Already in Use";
					return;
				} else {
					if (String(this.GuardianDesc) != String(this.OriginalDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringIntRequest = {
			str: this.GuardianDesc,
			num: this.SchoolID,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipDescUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Guardian Type Name/Description Already in Use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		let parms: ParentRelationshipUpdateRequest = {
			RelationshipID: this.SelectedGuardianType.RelationshipID,
			RelationshipCD: this.GuardianCD,
			RelationshipDesc: this.GuardianDesc,
		};

		var result = this.GuardianTypeSetupService.ParentRelationshipUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Guardian Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Guardian Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
